import { render } from "./navUser.vue?vue&type=template&id=348758e3&scoped=true"
import script from "./navUser.vue?vue&type=script&lang=js"
export * from "./navUser.vue?vue&type=script&lang=js"

import "./navUser.vue?vue&type=style&index=0&id=348758e3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348758e3"]])

export default __exports__